(function () {
	const header = () => {
		/* ── Legacy mega menu (old structure) ── */
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");
			});
			link.addEventListener("mouseleave", () => {
				setTimeout(() => {
					link.classList.remove("list-menu--megamenu-visible");
				}, 300);
			});
		});

		/* ================================================================
		   NEW MEGA MENU — Hover-intent with diagonal path detection
		   ================================================================
		   Behaviour:
		   - Hover a nav item → 250ms delay → open its panel
		   - Move mouse to panel → stays open (diagonal safe-zone)
		   - Leave both nav item AND panel → 350ms delay → close
		   - Click still works instantly (touch / keyboard fallback)
		   ============================================================= */

		const megaMenuBtns = document.querySelectorAll(".header__main-link[data-open-mega-menu]");
		const megaMenuPanels = document.querySelectorAll(".header__mega-menu-item .mega-menu-new");
		const megaMenuViewAllBtn = document.querySelector('.mega-menu-new__view-all');

		// Helper: find the mega-menu panel associated with a nav button
		// (panel is a sibling inside .header__mega-menu-item, not a child of the button)
		function getPanelForBtn(btn) {
			const wrapper = btn.closest('.header__mega-menu-item');
			return wrapper ? wrapper.querySelector('.mega-menu-new') : null;
		}

		// Timers and state
		let openTimer = null;
		let closeTimer = null;
		let activeBtn = null;       // Currently hovered/open nav button
		let activePanel = null;      // Currently open panel
		let lastMousePos = { x: 0, y: 0 };
		let isTouch = false;

		// Detect touch to disable hover on hybrid devices
		document.addEventListener('touchstart', () => { isTouch = true; }, { once: true, passive: true });

		// Track mouse position for diagonal detection
		document.addEventListener('mousemove', (e) => {
			lastMousePos.x = e.clientX;
			lastMousePos.y = e.clientY;
			isTouch = false; // Mouse moved → not touch
		}, { passive: true });

		const OPEN_DELAY = 250;   // ms before opening on hover
		const CLOSE_DELAY = 350;  // ms before closing after leaving

		function openPanel(btn, focusFirst) {
			const panel = getPanelForBtn(btn);
			if (!panel) return;

			// Close any other open panels + update aria
			megaMenuPanels.forEach((p) => {
				if (p !== panel) p.classList.remove('open');
			});
			megaMenuBtns.forEach((b) => {
				if (b !== btn) {
					b.classList.remove('list-menu--megamenu-visible');
					b.setAttribute('aria-expanded', 'false');
				}
			});

			btn.classList.add("list-menu--megamenu-visible");
			btn.setAttribute('aria-expanded', 'true');
			panel.classList.add('open');
			activeBtn = btn;
			activePanel = panel;

			// Focus first link inside panel for keyboard users
			const firstLink = panel.querySelector('a, button:not(.mega-menu-new__close-btn)');
			if (firstLink && focusFirst && !isTouch) {
				// Slight delay to allow CSS transition to start
				setTimeout(() => firstLink.focus({ preventScroll: true }), 50);
			}
		}

		function closeAllPanels() {
			const prevBtn = activeBtn;
			megaMenuPanels.forEach((p) => p.classList.remove('open'));
			megaMenuBtns.forEach((b) => {
				b.classList.remove('list-menu--megamenu-visible');
				b.setAttribute('aria-expanded', 'false');
			});
			activeBtn = null;
			activePanel = null;

			// Return focus to trigger button
			if (prevBtn && document.activeElement && document.activeElement.closest('.mega-menu-new')) {
				prevBtn.focus({ preventScroll: true });
			}
		}

		function clearTimers() {
			clearTimeout(openTimer);
			clearTimeout(closeTimer);
			openTimer = null;
			closeTimer = null;
		}

		/**
		 * Diagonal path detection:
		 * When the mouse leaves a nav item, check if it's moving toward the
		 * open mega menu panel. If the mouse is within a triangular "safe zone"
		 * from the nav item to the panel edges, keep the panel open.
		 */
		function isMovingTowardPanel(btn, panel) {
			if (!panel) return false;
			const panelRect = panel.getBoundingClientRect();
			const btnRect = btn.getBoundingClientRect();
			const mx = lastMousePos.x;
			const my = lastMousePos.y;

			// Panel is below the nav item — check if mouse is between
			// the nav item bottom and the panel bottom, and within
			// a generous horizontal corridor
			const panelTop = panelRect.top;
			const panelLeft = panelRect.left - 40;  // extra tolerance
			const panelRight = panelRect.right + 40;
			const btnCenterX = btnRect.left + btnRect.width / 2;

			// Mouse is below nav item and above panel bottom
			if (my >= btnRect.bottom - 5 && my <= panelRect.bottom + 20) {
				// Check horizontal: within a triangle from btn center to panel edges
				const progress = Math.max(0, (my - btnRect.bottom) / (panelTop - btnRect.bottom + 1));
				const corridorLeft = btnCenterX + (panelLeft - btnCenterX) * progress;
				const corridorRight = btnCenterX + (panelRight - btnCenterX) * progress;

				if (mx >= corridorLeft && mx <= corridorRight) {
					return true;
				}
			}

			return false;
		}

		function scheduleClose(btn) {
			clearTimeout(closeTimer);
			closeTimer = setTimeout(() => {
				// Before closing, check if mouse has moved into the panel
				if (activePanel && isMovingTowardPanel(btn, activePanel)) {
					// Mouse is heading toward panel — reschedule
					scheduleClose(btn);
					return;
				}
				closeAllPanels();
			}, CLOSE_DELAY);
		}

		/* ── Nav button events ── */
		megaMenuBtns.forEach((btn) => {
			// Click — instant open (touch + keyboard fallback)
			btn.addEventListener("click", (e) => {
				e.stopImmediatePropagation();
				clearTimers();
				const panel = getPanelForBtn(btn);
				if (panel && panel.classList.contains('open')) {
					// Already open → close (toggle behavior on click)
					closeAllPanels();
				} else {
					openPanel(btn, true);
				}
			});

			// Hover — delayed open with intent detection
			btn.addEventListener("mouseenter", () => {
				if (isTouch) return;
				clearTimeout(closeTimer);
				closeTimer = null;

				// If a different panel is already open, switch immediately
				if (activePanel && activeBtn !== btn) {
					clearTimers();
					openPanel(btn, false);
					return;
				}

				// If this panel is already open, just cancel close
				if (activeBtn === btn) return;

				// Otherwise, schedule open after delay
				clearTimeout(openTimer);
				openTimer = setTimeout(() => {
					openPanel(btn, false);
				}, OPEN_DELAY);
			});

			btn.addEventListener("mouseleave", () => {
				if (isTouch) return;
				clearTimeout(openTimer);
				openTimer = null;

				// If this btn's panel is open, schedule close with diagonal check
				if (activeBtn === btn) {
					scheduleClose(btn);
				}
			});
		});

		/* ── Panel events ── */
		megaMenuPanels.forEach((panel) => {
			// Mouse enters panel → cancel close
			panel.addEventListener("mouseenter", () => {
				if (isTouch) return;
				clearTimeout(closeTimer);
				closeTimer = null;
			});

			// Mouse leaves panel → schedule close
			panel.addEventListener("mouseleave", () => {
				if (isTouch) return;
				if (activeBtn) {
					scheduleClose(activeBtn);
				}
			});

			// Close button inside panel
			const closeBtn = panel.querySelector('.mega-menu-new__close-btn');
			if (closeBtn) {
				closeBtn.addEventListener('click', (e) => {
					e.stopImmediatePropagation();
					clearTimers();
					closeAllPanels();
				});
			}
		});

		/* ── View All (overflow hamburger) → open main menu drawer ── */
		megaMenuViewAllBtn?.addEventListener('click', () => {
			clearTimers();
			closeAllPanels();
			const drawerSummary = document.querySelector('header-drawer:not(.header__shop) > details > summary');
			if (drawerSummary) drawerSummary.click();
		});

		/* ── Click outside to close ── */
		document.addEventListener("click", (event) => {
			if (!event.target.closest('.mega-menu-new') && !event.target.closest('[data-open-mega-menu]')) {
				clearTimers();
				closeAllPanels();
			}
		});

		/* ── Escape key to close ── */
		document.addEventListener("keydown", (e) => {
			if (e.key === 'Escape' && activePanel) {
				e.preventDefault();
				clearTimers();
				// Return focus to trigger before closing
				if (activeBtn) activeBtn.focus({ preventScroll: true });
				closeAllPanels();
			}
		});

		/* ── Enter / Space on trigger → open (keyboard support for div[role=button]) ── */
		megaMenuBtns.forEach((btn) => {
			btn.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					clearTimers();
					const panel = getPanelForBtn(btn);
					if (panel && panel.classList.contains('open')) {
						closeAllPanels();
					} else {
						openPanel(btn, true);
					}
				}
			});
		});

		/* ── Tab trap within open panel ── */
		document.addEventListener('keydown', (e) => {
			if (e.key !== 'Tab' || !activePanel) return;

			const focusable = activePanel.querySelectorAll(
				'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
			);
			if (focusable.length === 0) return;

			const first = focusable[0];
			const last = focusable[focusable.length - 1];

			if (e.shiftKey) {
				// Shift+Tab on first element → wrap to last
				if (document.activeElement === first || document.activeElement === activeBtn) {
					e.preventDefault();
					last.focus({ preventScroll: true });
				}
			} else {
				// Tab on last element → wrap to trigger button
				if (document.activeElement === last) {
					e.preventDefault();
					activeBtn.focus({ preventScroll: true });
				}
			}
		});

		/* ── Touch: tap outside to close ── */
		document.addEventListener('touchend', (event) => {
			if (activePanel && !event.target.closest('.mega-menu-new') && !event.target.closest('[data-open-mega-menu]')) {
				clearTimers();
				closeAllPanels();
			}
		}, { passive: true });

		/* ── Close mega menu on resize below desktop breakpoint ── */
		window.addEventListener('resize', () => {
			if (window.innerWidth < 1000 && activePanel) {
				clearTimers();
				closeAllPanels();
			}
		}, { passive: true });
	};

	/* ================================================================
	   COLLAPSING STICKY HEADER — Mobile only (<750px)
	   ================================================================
	   At page top: Full header (logo, search, store hours)
	   On scroll down past 80px: Collapse to slim bar (hamburger, mini logo, cart)
	   On scroll back to top: Expand back to full
	   ============================================================= */

	const collapsingHeader = () => {
		const headerSection = document.querySelector('.shopify-section-header');
		if (!headerSection) return;

		const COLLAPSE_AT = 80;    // px scrolled before collapsing
		const EXPAND_AT = 30;      // px from top to expand (hysteresis)
		let collapsed = false;
		let ticking = false;

		const update = () => {
			ticking = false;
			if (window.innerWidth >= 750) {
				if (collapsed) {
					document.body.classList.remove('header--collapsed');
					collapsed = false;
				}
				return;
			}

			const scrollY = window.scrollY;
			if (!collapsed && scrollY > COLLAPSE_AT) {
				document.body.classList.add('header--collapsed');
				collapsed = true;
			} else if (collapsed && scrollY <= EXPAND_AT) {
				document.body.classList.remove('header--collapsed');
				collapsed = false;
			}
		};

		window.addEventListener('scroll', () => {
			if (!ticking) {
				requestAnimationFrame(update);
				ticking = true;
			}
		}, { passive: true });

		// Reset on resize to desktop
		window.addEventListener('resize', () => {
			if (window.innerWidth >= 750 && collapsed) {
				document.body.classList.remove('header--collapsed');
				collapsed = false;
			}
		}, { passive: true });
	};

	/* ================================================================
	   SLIM PINNED HEADER — Desktop only (>=1000px), docs/header/07
	   ================================================================
	   At page top: the full header. After a short scroll: one slim row (logo, Rayons, search,
	   store, account, cart). "Rayons" brings the department bar back under the row.
	   The section keeps its place in the page's flow (a bottom margin makes up the height it
	   gives up), so the page never jumps when the header changes size.
	   ============================================================= */
	const slimHeader = () => {
		const section = document.querySelector('.shopify-section-header');
		if (!section) return;
		const btn = section.querySelector('[data-fg-rayons]');
		const wide = window.matchMedia('(min-width: 1000px)');
		const body = document.body;
		const SLIM_AT = 80;
		const FULL_AT = 24;
		let slim = false;
		let open = false;
		let full = 0;
		let ticking = false;
		let hoverTimer = null;

		const fit = () => {
			section.style.marginBottom = slim ? Math.max(0, full - section.offsetHeight) + 'px' : '';
			/* bars pinned under the header place themselves on scroll (collection filters) or on this event (product page) */
			window.dispatchEvent(new Event('scroll'));
			document.dispatchEvent(new CustomEvent('fg:header-resize'));
		};
		const setOpen = (value) => {
			value = !!value && slim;
			if (value === open) return;
			open = value;
			body.classList.toggle('fg-rayons-open', open);
			if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (!open) {
				/* an open panel belongs to the bar that is leaving */
				section.querySelectorAll('.mega-menu-new.open').forEach((p) => p.classList.remove('open'));
				section.querySelectorAll('.header__main-link[aria-expanded="true"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
			}
			fit();
		};
		const setSlim = (value) => {
			if (value === slim) return;
			if (value) full = section.offsetHeight;
			slim = value;
			body.classList.toggle('fg-header-slim', slim);
			if (!slim) setOpen(false);
			fit();
		};
		const update = () => {
			ticking = false;
			if (!wide.matches) { setSlim(false); return; }
			const y = window.scrollY;
			if (!slim && y > SLIM_AT) setSlim(true);
			else if (slim && y <= FULL_AT) setSlim(false);
		};

		window.addEventListener('scroll', () => {
			if (!ticking) { ticking = true; requestAnimationFrame(update); }
		}, { passive: true });
		window.addEventListener('resize', () => { setSlim(false); update(); }, { passive: true });
		update();

		if (!btn) return;
		btn.addEventListener('click', (e) => {
			e.stopPropagation();
			clearTimeout(hoverTimer);
			setOpen(!open);
		});
		btn.addEventListener('mouseenter', () => {
			clearTimeout(hoverTimer);
			hoverTimer = setTimeout(() => setOpen(true), 180);
		});
		section.addEventListener('mouseenter', () => clearTimeout(hoverTimer));
		section.addEventListener('mouseleave', () => {
			clearTimeout(hoverTimer);
			hoverTimer = setTimeout(() => {
				if (!section.querySelector('.mega-menu-new:hover') && !section.contains(document.activeElement)) setOpen(false);
			}, 500);
		});
		document.addEventListener('click', (e) => {
			if (open && !e.target.closest('.shopify-section-header')) setOpen(false);
		});
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && open && !e.defaultPrevented && !section.querySelector('.mega-menu-new.open')) {
				setOpen(false);
				btn.focus({ preventScroll: true });
			}
		});
	};

	document.addEventListener("shopify:section:load", header);
	header();
	collapsingHeader();
	slimHeader();
})();
